import { render, staticRenderFns } from "./ShowSelectedSidebar.vue?vue&type=template&id=6f1f2c00&scoped=true&"
import script from "./ShowSelectedSidebar.vue?vue&type=script&lang=js&"
export * from "./ShowSelectedSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ShowSelectedSidebar.vue?vue&type=style&index=0&id=6f1f2c00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1f2c00",
  null
  
)

export default component.exports